//
import ProductModel from "@/models/Warehouse/WhProduct"

//
import ProductFilters from "@/views/Warehouse/WhProduct/list/filters"
import ProductHeaders from "@/views/Warehouse/WhProduct/list/headers"

//
import DetailHeaders from "./headers"

//
export default [
    {
        name: "internal_code",
        type: "text-field",
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: "Código interno",
            readonly: true,
        },
    },
    {
        name: "alias_name",
        type: "text-field",
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: "Alias",
            readonly: true,
        },
    },
    {
        name: "name",
        type: "text-field",
        flex: {
            sm6: true,
            lg4: true,
        },
        props: {
            label: "Nombre",
            readonly: true,
        },        
    },
    {
        name: "wh_repacking_products",
        type: "data-table-model",
        flex: {
            "pt-0": true,
            xs12: true,
        },
        props: {
            checkable: true,
            class: "v-card elevation-2 mb-4",
            headers: DetailHeaders,
            noActions: true,
            noDataText: "Sin productos.",
            noFilter: true,
            noExport: true,
            noHelper: true,
            noPagination: true,
            noSearch: true,
            pickerProps: {
                filters: ProductFilters({}).slice(0, -1),
                headers: ProductHeaders,
                noPagination: false,
                submitText: "confirmar selección",
                service: ProductModel,
            },
            showNativePagination: true,
            showPicker: true,
            toolbarTitle: "Lista de productos reenvasados",
            toolbarColor: "primary",
            toolbarDark: true,
            toolbarDense: true,
        },
    },
]